import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Navigation } from '../components/Navigation';
import { Section } from '../components/ui/Section';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import { PhotoGalleryModal } from '../components/PhotoGalleryModal';
import { MapPin, ShieldCheck, Zap, Filter, Map as MapIcon, Camera, Star, Wifi, Droplets, Lock, Grid3x3, List, TrendingUp } from 'lucide-react';
import { motion } from 'framer-motion';
const hostels = [{
  id: 1,
  name: 'Emerald Heights',
  location: 'Unilag, Akoka',
  price: '₦450,000',
  period: '/session',
  verified: true,
  rating: 4.8,
  reviews: 24,
  amenities: ['24/7 Power', 'Security', 'Water', 'WiFi'],
  type: 'Self-contain',
  featured: true,
  images: ['https://images.unsplash.com/photo-1555854877-bab0e564b8d5?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1556911220-e15b29be8c8f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'],
  captions: ['Bedroom', 'Kitchen', 'Bathroom', 'Exterior']
}, {
  id: 2,
  name: 'Sunshine Lodge',
  location: 'Yaba Tech, Yaba',
  price: '₦250,000',
  period: '/session',
  verified: true,
  rating: 4.5,
  reviews: 18,
  amenities: ['Water', 'Security', 'WiFi'],
  type: 'Single Room',
  featured: false,
  images: ['https://images.unsplash.com/photo-1596276020587-8044fe049813?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1595526114035-0d45ed16cfbf?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1512918760532-3ed00af63671?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'],
  captions: ['Room View', 'Bedroom', 'Common Area']
}, {
  id: 3,
  name: 'The Haven',
  location: 'Unilag, Bariga',
  price: '₦600,000',
  period: '/session',
  verified: true,
  rating: 4.9,
  reviews: 31,
  amenities: ['AC', '24/7 Power', 'Gym', 'WiFi'],
  type: 'Flat',
  featured: true,
  images: ['https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'],
  captions: ['Living Area', 'Bedroom', 'Kitchen']
}, {
  id: 4,
  name: 'Student Village',
  location: 'LUTH, Idi-Araba',
  price: '₦350,000',
  period: '/session',
  verified: true,
  rating: 4.3,
  reviews: 15,
  amenities: ['Security', 'Common Room', 'Water'],
  type: 'Shared',
  featured: false,
  images: ['https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1555854877-bab0e564b8d5?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'],
  captions: ['Shared Room', 'Study Area', 'Bathroom']
}, {
  id: 5,
  name: 'Royal Residence',
  location: 'FUTA, Akure',
  price: '₦380,000',
  period: '/session',
  verified: true,
  rating: 4.7,
  reviews: 22,
  amenities: ['24/7 Power', 'Security', 'Water', 'Parking'],
  type: 'Self-contain',
  featured: true,
  images: ['https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1556911220-e15b29be8c8f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'],
  captions: ['Bedroom', 'Living Room', 'Kitchen']
}, {
  id: 6,
  name: 'Campus View Apartments',
  location: 'Covenant University',
  price: '₦520,000',
  period: '/session',
  verified: true,
  rating: 4.6,
  reviews: 19,
  amenities: ['AC', 'WiFi', 'Security', '24/7 Power'],
  type: 'Self-contain',
  featured: false,
  images: ['https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1595526114035-0d45ed16cfbf?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'],
  captions: ['Bedroom', 'Study Area', 'Bathroom']
}, {
  id: 7,
  name: 'Green Park Lodge',
  location: 'UI, Ibadan',
  price: '₦320,000',
  period: '/session',
  verified: true,
  rating: 4.4,
  reviews: 16,
  amenities: ['Water', 'Security', 'Parking', 'WiFi'],
  type: 'Single Room',
  featured: false,
  images: ['https://images.unsplash.com/photo-1555854877-bab0e564b8d5?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1596276020587-8044fe049813?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1512918760532-3ed00af63671?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'],
  captions: ['Room', 'Entrance', 'Common Area']
}, {
  id: 8,
  name: 'Elite Suites',
  location: 'Babcock University',
  price: '₦480,000',
  period: '/session',
  verified: true,
  rating: 4.8,
  reviews: 27,
  amenities: ['AC', '24/7 Power', 'WiFi', 'Gym', 'Pool'],
  type: 'Flat',
  featured: false,
  images: ['https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'],
  captions: ['Living Room', 'Bedroom', 'Kitchen']
}, {
  id: 9,
  name: 'Scholars Den',
  location: 'LASU, Ojo',
  price: '₦280,000',
  period: '/session',
  verified: true,
  rating: 4.2,
  reviews: 12,
  amenities: ['Water', 'Security', 'Study Room'],
  type: 'Shared',
  featured: false,
  images: ['https://images.unsplash.com/photo-1596276020587-8044fe049813?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1555854877-bab0e564b8d5?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'],
  captions: ['Shared Room', 'Bedroom', 'Bathroom']
}];
export function FindHostelPage() {
  const [showMap, setShowMap] = useState(false);
  const [galleryOpen, setGalleryOpen] = useState(false);
  const [selectedHostel, setSelectedHostel] = useState<(typeof hostels)[0] | null>(null);
  const [viewMode, setViewMode] = useState<'grid' | 'list'>('grid');
  const [sortBy, setSortBy] = useState('featured');
  const navigate = useNavigate();
  const openGallery = (e: React.MouseEvent, hostel: (typeof hostels)[0]) => {
    e.stopPropagation();
    setSelectedHostel(hostel);
    setGalleryOpen(true);
  };
  let sortedHostels = [...hostels];
  if (sortBy === 'price-low') {
    sortedHostels.sort((a, b) => parseInt(a.price.replace(/[₦,]/g, '')) - parseInt(b.price.replace(/[₦,]/g, '')));
  } else if (sortBy === 'price-high') {
    sortedHostels.sort((a, b) => parseInt(b.price.replace(/[₦,]/g, '')) - parseInt(a.price.replace(/[₦,]/g, '')));
  } else if (sortBy === 'rating') {
    sortedHostels.sort((a, b) => b.rating - a.rating);
  }
  const featuredHostels = sortedHostels.filter(h => h.featured);
  const regularHostels = sortedHostels.filter(h => !h.featured);
  return <div className="min-h-screen bg-slate-50 pt-20" data-id="element-533" data-mp="iasyc16urd7r">
      <Navigation data-id="element-534" data-mp="n9vzvbnmj1az" />

      {selectedHostel && <PhotoGalleryModal isOpen={galleryOpen} onClose={() => setGalleryOpen(false)} images={selectedHostel.images} captions={selectedHostel.captions} data-id="element-535" data-mp="n8kwve205xkx" />}

      {/* Search Header */}
      <div className="bg-white border-b border-slate-200 sticky top-20 z-20 shadow-sm" data-id="element-536" data-mp="3vpfp7zl6bzkr">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-537" data-mp="4ai4cpa8xiid">
          <div className="flex flex-col md:flex-row gap-4 items-center justify-between" data-id="element-538" data-mp="4bt6ylrygk7w">
            <div className="flex items-center gap-2 w-full md:w-auto" data-id="element-539" data-mp="32zyzxasuoysr">
              <div className="relative flex-1 md:w-80" data-id="element-540" data-mp="37yjqsjm7q64j">
                <MapPin className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 w-5 h-5" data-id="element-541" data-mp="37x8qitrz7gi6" />
                <input type="text" placeholder="Search by campus or area..." className="w-full pl-10 pr-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:outline-none" data-id="element-542" data-mp="1l2vosmrz8z7x" />
              </div>
              <Button variant="outline" className="md:hidden" data-id="element-543" data-mp="1b720650zhf9s">
                <Filter className="w-5 h-5" data-id="element-544" data-mp="1675ywdjo81xx" />
              </Button>
            </div>

            <div className="flex items-center gap-3 w-full md:w-auto overflow-x-auto pb-2 md:pb-0" data-id="element-545" data-mp="11dtk0v4sn9id">
              <select value={sortBy} onChange={e => setSortBy(e.target.value)} className="h-9 rounded-md border border-slate-300 bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-brand-primary whitespace-nowrap" data-id="element-546" data-mp="xe2oyf88i781">
                <option value="featured" data-id="element-547" data-mp="ih1vo7aea47g">Featured First</option>
                <option value="price-low" data-id="element-548" data-mp="28vihc3g7g5e9">Price: Low to High</option>
                <option value="price-high" data-id="element-549" data-mp="28tnu2ihgo170">Price: High to Low</option>
                <option value="rating" data-id="element-550" data-mp="23vw2xqon4j3v">Highest Rated</option>
              </select>
              <div className="h-6 w-px bg-slate-300 mx-2 hidden md:block" data-id="element-551" data-mp="2hobzq9qy7kwc"></div>
              <div className="flex border border-slate-300 rounded-md overflow-hidden" data-id="element-552" data-mp="2dmqsp513i0u2">
                <button onClick={() => setViewMode('grid')} className={`p-2 ${viewMode === 'grid' ? 'bg-brand-primary text-white' : 'bg-white text-slate-600'}`} data-id="element-553" data-mp="1pwwh0qsiiibe">
                  <Grid3x3 className="w-4 h-4" data-id="element-554" data-mp="1yy422760pmnj" />
                </button>
                <button onClick={() => setViewMode('list')} className={`p-2 ${viewMode === 'list' ? 'bg-brand-primary text-white' : 'bg-white text-slate-600'}`} data-id="element-555" data-mp="1yv85am5wp40o">
                  <List className="w-4 h-4" data-id="element-556" data-mp="35dwtlnon42ke" />
                </button>
              </div>
              <Button variant={showMap ? 'primary' : 'outline'} size="sm" onClick={() => setShowMap(!showMap)} className="whitespace-nowrap" data-id="element-557" data-mp="3duoum8wlcwj9">
                <MapIcon className="w-4 h-4 mr-2" data-id="element-558" data-mp="33x109k2wdr1m" />
                {showMap ? 'Show List' : 'Show Map'}
              </Button>
            </div>
          </div>
        </div>
      </div>

      <Section className="!py-8" data-id="element-559" data-mp="g0vot87fyim">
        <div className="flex gap-8" data-id="element-560" data-mp="gtwzeoe9vtd">
          {/* Filters Sidebar - Desktop */}
          <div className="hidden lg:block w-64 flex-shrink-0 space-y-6" data-id="element-561" data-mp="5f52jd7npk5s">
            <div data-id="element-562" data-mp="3mvd72z6c6ou1">
              <h3 className="font-semibold text-brand-dark mb-3" data-id="element-563" data-mp="3mvvdupqmklg7">Campus</h3>
              <div className="space-y-2" data-id="element-564" data-mp="3rugcikq8ax2j">
                {['FUTA', 'Unilag', 'Yaba Tech', 'LUTH', 'Covenant', 'Babcock', 'UI', 'LASU'].map(campus => <label key={campus} className="flex items-center gap-2 text-sm text-slate-600" data-id="element-565" data-mp="y1vbvk05if3s">
                    <input type="checkbox" className="rounded border-slate-300 text-brand-primary focus:ring-brand-primary" data-id="element-566" data-mp="t05yvytdbrd2" />
                    {campus}
                  </label>)}
              </div>
            </div>

            <div data-id="element-567" data-mp="f4kgwbljy7u5">
              <h3 className="font-semibold text-brand-dark mb-3" data-id="element-568" data-mp="abrc5nq32zi2">Room Type</h3>
              <div className="space-y-2" data-id="element-569" data-mp="a9oc0av7vpzm">
                {['Self-contain', 'Single Room', 'Shared', 'Flat'].map(type => <label key={type} className="flex items-center gap-2 text-sm text-slate-600" data-id="element-570" data-mp="ecvpo45uapr">
                      <input type="checkbox" className="rounded border-slate-300 text-brand-primary focus:ring-brand-primary" data-id="element-571" data-mp="3sj72buh3u1zr" />
                      {type}
                    </label>)}
              </div>
            </div>

            <div data-id="element-572" data-mp="2c0f3owjiql0d">
              <h3 className="font-semibold text-brand-dark mb-3" data-id="element-573" data-mp="2c1zx2iu3jxwn">Amenities</h3>
              <div className="space-y-2" data-id="element-574" data-mp="2h0ji8h0v95ny">
                {['24/7 Power', 'Water', 'Security', 'AC', 'Kitchen', 'WiFi', 'Gym'].map(item => <label key={item} className="flex items-center gap-2 text-sm text-slate-600" data-id="element-575" data-mp="1tap47w4t9b24">
                    <input type="checkbox" className="rounded border-slate-300 text-brand-primary focus:ring-brand-primary" data-id="element-576" data-mp="1y2goxq1acmkc" />
                    {item}
                  </label>)}
              </div>
            </div>
          </div>

          {/* Grid */}
          <div className="flex-1" data-id="element-577" data-mp="338oxq1rvc7az">
            <h2 className="text-xl font-bold text-brand-dark mb-6" data-id="element-578" data-mp="339i06qjsoanb">
              {hostels.length} Verified Hostels Found
            </h2>

            {/* Featured Hostels */}
            {featuredHostels.length > 0 && <div className="mb-8" data-id="element-579" data-mp="3c7txtcj2w8p9">
                <div className="flex items-center gap-2 mb-4" data-id="element-580" data-mp="3qxrd12z15o2b">
                  <TrendingUp className="w-5 h-5 text-brand-primary" data-id="element-581" data-mp="3qw6llm80il8o" />
                  <h3 className="text-lg font-bold text-brand-dark" data-id="element-582" data-mp="3ly506un469u1">
                    Featured Hostels
                  </h3>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-583" data-mp="3vx4bym36ell9">
                  {featuredHostels.map((hostel, index) => <motion.div key={hostel.id} initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                delay: index * 0.1
              }} data-id="element-584" data-mp="25lg5lnxd4000" data-mpi={index}>
                      <Card className="overflow-hidden hover:shadow-md transition-shadow group cursor-pointer h-full flex flex-col border-brand-primary/30" onClick={() => navigate(`/hostel/${hostel.id}`)} data-id="element-585" data-mp="1mog18mxb1up3">
                        <div className="relative h-48 overflow-hidden" data-id="element-586" data-mp="1crjna1on0gd5">
                          <img src={hostel.images[0]} alt={hostel.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-587" data-mp="yrsfwjsmly84" />
                          {hostel.verified && <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm px-2 py-1 rounded-full flex items-center gap-1 text-xs font-bold text-emerald-700 shadow-sm z-10" data-id="element-588" data-mp="2y1igneno4e7o">
                              <ShieldCheck className="w-3 h-3" data-id="element-589" data-mp="2rpflk8s7v82m" />
                              VERIFIED
                            </div>}
                          <div className="absolute top-3 left-3 px-2 py-1 bg-brand-primary text-white text-xs font-bold rounded-full z-10" data-id="element-590" data-mp="2hq6txmktq5jf">
                            FEATURED
                          </div>
                          <div className="absolute bottom-3 left-3 bg-brand-dark/80 backdrop-blur-sm px-2 py-1 rounded text-xs font-medium text-white z-10" data-id="element-591" data-mp="3af5culwrtbps">
                            {hostel.type}
                          </div>

                          <button onClick={e => openGallery(e, hostel)} className="absolute bottom-3 right-3 bg-black/50 hover:bg-black/70 text-white p-1.5 rounded-full backdrop-blur-sm transition-colors z-10" data-id="element-592" data-mp="30lwvj8ougzws">
                            <Camera className="w-4 h-4" data-id="element-593" data-mp="4kjrptsdmpt6" />
                          </button>
                        </div>

                        <div className="p-4 flex-1 flex flex-col" data-id="element-594" data-mp="egmtgyjbgmfl">
                          <div className="flex justify-between items-start mb-2" data-id="element-595" data-mp="efbpoypvfeoh">
                            <div data-id="element-596" data-mp="jhasa6dse7kd">
                              <h3 className="font-bold text-brand-dark text-lg" data-id="element-597" data-mp="jdd7zhfh39yw">
                                {hostel.name}
                              </h3>
                              <p className="text-slate-500 text-sm flex items-center gap-1" data-id="element-598" data-mp="setg1iitezzy">
                                <MapPin className="w-3 h-3" data-id="element-599" data-mp="x8fikhv9lni1" /> {hostel.location}
                              </p>
                            </div>
                          </div>

                          <div className="flex items-center gap-1 mb-3" data-id="element-600" data-mp="1763g1fk9993w">
                            <Star className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-601" data-mp="1b6m9tf5pkp8q" />
                            <span className="font-bold text-sm" data-id="element-602" data-mp="1b4jd6ca1vxv1">
                              {hostel.rating}
                            </span>
                            <span className="text-xs text-slate-500" data-id="element-603" data-mp="1sf7ebyjh49g2">
                              ({hostel.reviews} reviews)
                            </span>
                          </div>

                          <div className="flex flex-wrap gap-2 mb-4" data-id="element-604" data-mp="21hyrc2rzzd9t">
                            {hostel.amenities.slice(0, 3).map(amenity => <span key={amenity} className="text-xs bg-slate-100 text-slate-600 px-2 py-1 rounded-full flex items-center gap-1" data-id="element-605" data-mp="1dp02i1nz1ooc">
                                {amenity === '24/7 Power' ? <Zap className="w-3 h-3" data-id="element-606" data-mp="1iomj8l30dn1w" /> : amenity === 'Water' ? <Droplets className="w-3 h-3" data-id="element-607" data-mp="q2a3zaau0c8h" /> : amenity === 'Security' ? <Lock className="w-3 h-3" data-id="element-608" data-mp="31obxjdpg0jzk" /> : amenity === 'WiFi' ? <Wifi className="w-3 h-3" data-id="element-609" data-mp="36h52a1kwvsbn" /> : null}
                                {amenity}
                              </span>)}
                          </div>

                          <div className="mt-auto pt-4 border-t border-slate-100 flex items-center justify-between" data-id="element-610" data-mp="3kfv23oz4863p">
                            <div data-id="element-611" data-mp="3pey8bcqu0id9">
                              <span className="text-lg font-bold text-brand-primary" data-id="element-612" data-mp="3pdwux1mcfjsd">
                                {hostel.price}
                              </span>
                              <span className="text-xs text-slate-400" data-id="element-613" data-mp="3gcyoydsch275">
                                {hostel.period}
                              </span>
                            </div>
                            <Button size="sm" data-id="element-614" data-mp="24z4mx0qd3vaf">View Details</Button>
                          </div>
                        </div>
                      </Card>
                    </motion.div>)}
                </div>
              </div>}

            {/* Regular Hostels */}
            <div className={viewMode === 'grid' ? 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6' : 'space-y-4'} data-id="element-615" data-mp="25auaa8lujvng">
              {regularHostels.map((hostel, index) => <motion.div key={hostel.id} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: index * 0.05
            }} data-id="element-616" data-mp="218h6hpqnu7tb" data-mpi={index}>
                  <Card className={`overflow-hidden hover:shadow-md transition-shadow group cursor-pointer ${viewMode === 'list' ? 'flex flex-row' : 'h-full flex flex-col'}`} onClick={() => navigate(`/hostel/${hostel.id}`)} data-id="element-617" data-mp="1dl93jegpfaug">
                    <div className={`relative overflow-hidden ${viewMode === 'list' ? 'w-48 h-48' : 'h-48'}`} data-id="element-618" data-mp="tz65n0mb4wt3">
                      <img src={hostel.images[0]} alt={hostel.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-619" data-mp="12wq6w9k66t3p" />
                      {hostel.verified && <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm px-2 py-1 rounded-full flex items-center gap-1 text-xs font-bold text-emerald-700 shadow-sm z-10" data-id="element-620" data-mp="1qmar0vs27wek">
                          <ShieldCheck className="w-3 h-3" data-id="element-621" data-mp="20ml5ejptz9vb" />
                          VERIFIED
                        </div>}
                      <div className="absolute bottom-3 left-3 bg-brand-dark/80 backdrop-blur-sm px-2 py-1 rounded text-xs font-medium text-white z-10" data-id="element-622" data-mp="1vkccfncyk7t7">
                        {hostel.type}
                      </div>

                      <button onClick={e => openGallery(e, hostel)} className="absolute bottom-3 right-3 bg-black/50 hover:bg-black/70 text-white p-1.5 rounded-full backdrop-blur-sm transition-colors z-10" data-id="element-623" data-mp="129z2sryktcg7">
                        <Camera className="w-4 h-4" data-id="element-624" data-mp="1c1v0w30nx2kf" />
                      </button>
                    </div>

                    <div className="p-4 flex-1 flex flex-col" data-id="element-625" data-mp="1l070uvnf5cpj">
                      <div className="flex justify-between items-start mb-2" data-id="element-626" data-mp="1l0qazq6tuwt0">
                        <div data-id="element-627" data-mp="1py8gf6lmytw9">
                          <h3 className="font-bold text-brand-dark text-lg" data-id="element-628" data-mp="1px77p8s3ejhp">
                            {hostel.name}
                          </h3>
                          <p className="text-slate-500 text-sm flex items-center gap-1" data-id="element-629" data-mp="3rpv2ctqo7ylv">
                            <MapPin className="w-3 h-3" data-id="element-630" data-mp="3k7nha6o6yiwh" /> {hostel.location}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-center gap-1 mb-3" data-id="element-631" data-mp="3fec8hzztjs1x">
                        <Star className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-632" data-mp="3ai3xmysnml0k" />
                        <span className="font-bold text-sm" data-id="element-633" data-mp="35jai70tt4jxr">
                          {hostel.rating}
                        </span>
                        <span className="text-xs text-slate-500" data-id="element-634" data-mp="6zu36619iqm0">
                          ({hostel.reviews} reviews)
                        </span>
                      </div>

                      <div className="flex flex-wrap gap-2 mb-4" data-id="element-635" data-mp="3t6iljd7odix5">
                        {hostel.amenities.slice(0, 3).map(amenity => <span key={amenity} className="text-xs bg-slate-100 text-slate-600 px-2 py-1 rounded-full flex items-center gap-1" data-id="element-636" data-mp="3p8l08lh0zgz1">
                            {amenity === '24/7 Power' ? <Zap className="w-3 h-3" data-id="element-637" data-mp="5gaeq59d9z5x" /> : amenity === 'Water' ? <Droplets className="w-3 h-3" data-id="element-638" data-mp="aawne0o2ddmb" /> : amenity === 'Security' ? <Lock className="w-3 h-3" data-id="element-639" data-mp="iqzb20xngce" /> : amenity === 'WiFi' ? <Wifi className="w-3 h-3" data-id="element-640" data-mp="o8lcjkp5z6x6" /> : null}
                            {amenity}
                          </span>)}
                      </div>

                      <div className="mt-auto pt-4 border-t border-slate-100 flex items-center justify-between" data-id="element-641" data-mp="f7esx2r7xfzp">
                        <div data-id="element-642" data-mp="j87441jnhuym">
                          <span className="text-lg font-bold text-brand-primary" data-id="element-643" data-mp="2zyf8t7tzfvft">
                            {hostel.price}
                          </span>
                          <span className="text-xs text-slate-400" data-id="element-644" data-mp="341ka572btr2v">
                            {hostel.period}
                          </span>
                        </div>
                        <Button size="sm" data-id="element-645" data-mp="2ri6fzblvqbhs">View Details</Button>
                      </div>
                    </div>
                  </Card>
                </motion.div>)}
            </div>
          </div>
        </div>
      </Section>
    </div>;
}